import React from 'react';
import block from 'propmods';

import './FormError.scss';

const b = block('FormError');

interface Props {
    offsetTop?: boolean;
}

export const FormError: React.FC<Props> = ({ children, offsetTop }) => {
    return <div {...b({ 'offset-top': offsetTop })}>{children}</div>;
};
